import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface InvoiceAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  title: string;
  description?: string;
  tenant: OD3_Tenant;
  draft: boolean;
  deleted: boolean;
  order: number;
  icon?: string;
}

export class Invoice extends Parse.Object<InvoiceAttributes> {
  constructor(data?: Partial<InvoiceAttributes>) {
    super("APP_Invoice", data as InvoiceAttributes);
  }
}

Parse.Object.registerSubclass("APP_Invoice", Invoice);
